import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

export default function PubliserDetails({ publishers }) {
  return (
    <Box sx={{ minWidth: "900px", maxWidth: "100%" }}>
      <TableContainer>
        <Table size="small">
          <TableHead
            sx={{
              "& tr th": {
                background: (theme) => theme.palette.primary.lighter,
                color: (theme) => theme.palette.primary.darker,
                paddingLeft: "8px",
              },
            }}
          >
            <TableRow>
              <TableCell>Publisher Name</TableCell>
              <TableCell>Ordered Qty</TableCell>
              <TableCell>Received Quantity</TableCell>
              <TableCell>Pending Order Quantity</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {publishers?.length > 0 ? (
              publishers.map((publisher, index) => (
                <TableRow key={index}>
                  <TableCell>{publisher.publisher_name || "-"}</TableCell>
                  <TableCell>{publisher.po_quantity || 0}</TableCell>
                  <TableCell>{publisher.received_quantity || 0}</TableCell>
                  <TableCell>{publisher.pending_order_quantity || 0}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  No publisher details available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
